import {ListItemIcon} from '@mui/material';
import {styled} from '@mui/material/styles/index.js';

export default styled(ListItemIcon)(({theme}) => ({
  color:
    theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : '',
}));
